import React from 'react';

const EditorLayout = ({ title, subtitle, tabs = [], activeTab, onTabChange, actions, children, sidebar }) => {
    return (
        <div className="flex flex-col h-full">
            {/* Header */}
            <header className="sticky top-0 z-30 bg-surface/80 backdrop-blur-md border-b border-outlineVariant px-6 py-4">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                        <h1 className="text-headline-small font-bold text-surface-on">{title}</h1>
                        {subtitle && <p className="text-body-medium text-surface-onVariant">{subtitle}</p>}
                    </div>
                    <div className="flex items-center gap-3">
                        {actions}
                    </div>
                </div>

                {/* Tabs */}
                {tabs.length > 0 && (
                    <div className="mt-4 flex gap-1 overflow-x-auto no-scrollbar">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => onTabChange(tab.id)}
                                className={`px-6 py-2 rounded-full text-label-large font-bold transition-all ${
                                    activeTab === tab.id
                                        ? 'bg-primary text-primary-on shadow-elevation-1'
                                        : 'text-surface-onVariant hover:bg-surface-on/5'
                                }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                )}
            </header>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
                {/* Main Editor */}
                <main className="flex-1 overflow-y-auto p-6 md:p-10">
                    <div className="w-full">
                        {children}
                    </div>
                </main>

                {/* Optional Sidebar (Preview/Settings) */}
                {sidebar && (
                    <aside className="w-full lg:w-[400px] border-l border-outlineVariant bg-surface-containerLow overflow-y-auto hidden lg:block">
                        <div className="sticky top-0 p-6 md:p-8">
                            {sidebar}
                        </div>
                    </aside>
                )}
            </div>
        </div>
    );
};

export default EditorLayout;
